/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.20",
    versionName: "local 0.2.0-nightly.2025.10.20",
    versionChannel: "local",
    buildDate: "2025-12-01T06:28:38.236Z",
    commitHash: "5353887121aaf6c436158a24d2dbf82fb9bc9164",
};
